// import evaluateOutputCalculation from "./evaluateOutputCalculation";
import getFlattenedResponses from "./getFlattenedResponses";

const checkIfOutputIsVisible = (output, context, skipContextChecks=false) => {
  const { responses: unflattened } = context;
  const responses = getFlattenedResponses(unflattened);

  const crossConfig = context?.crossData?.[output.service_block_id]?.[output.id];

  const flg_output_visibility = crossConfig?.flg_output_visibility || output?.flg_output_visibility;

  const ctxChecks = [["WEB", 1 << 0], ["PDF", 1 << 1]];
  if (
    !!context?.context
    && !skipContextChecks
    && ctxChecks.some(([ctx, bit]) =>
      ctx === context.context
      && !(bit & flg_output_visibility)
    )
  )
    return false;

  if (output.output_type === "question") {
    if (output?.output_input_id && responses[output.output_input_id]) {
      return true;
    }
    return false;
  }

  // if (output.output_type === "calculation") {
  // if (
  //   output.calculation?.length &&
  //   output.calculation
  //     .filter((v) => v[0] === "{") // get only values
  //     .reduce((acc, stringObj) => {
  //       // check if value is required and user has answared to that question
  //       const { required, inputId, outputId } = JSON.parse(stringObj);

  //       if (!acc) {
  //         return acc;
  //       }

  //       // if (outputId) {
  //       //   const outputToCheck = configuration.find((b) => b.id === outputId);
  //       //   // check if calculation exists
  //       //   if (
  //       //     outputToCheck &&
  //       //     checkIfOutputIsVisible(outputToCheck, context)
  //       //   ) {
  //       //     return acc;
  //       //   }

  //       //   return false;
  //       // }

  //       if (!required) {
  //         return acc;
  //       }

  //       if (!responses[inputId]) {
  //         return false;
  //       }

  //       return acc;
  //     }, true)
  // ) {
  //   return true;
  // }

  // const result = evaluateOutputCalculation(output, context);

  // if (result) {
  //   return true;
  // }
  // return false;
  //   return true;
  // }

  return true;
};

export default checkIfOutputIsVisible;
